import React from 'react';
import Image from 'next/image';
import errorIllustration from '../../../../public/images/error/500.svg';
import { Button, StyledLink } from '@clara/ui';

export function InternalServerErrorPage() {
  return (
    <div className="grid justify-items-center text-center p-b-1-5">
      <Image src={errorIllustration} alt="Illustration of an internal server error" priority />
      <div className="grid  gap-24 justify-items-center w-full">
        <div className="grid">
          <h2 className="h2 primary-text-color-submain-normal lg:mt-[var(--h6)]! mb-[var(--h6)]">Internal Server Error</h2>

          <p className="p1 primary-text-color-submain-normal">Sorry for the inconvenience.</p>
          <p className="p1 primary-text-color-submain-normal">Please report this message and include the following information to us.</p>
          <p className="p1 primary-text-color-submain-normal">Thank you very much!</p>
        </div>

        <Button styleType="outline" variant="primary">
          Email Us
        </Button>

        <StyledLink href="#" variant="secondary" className="p-b-1-5">
          Back To Previous Page
        </StyledLink>
      </div>
    </div>
  );
}
